import inject from './inject';
import SummaryComponent from './Summary';

const Summary = inject(SummaryComponent);
export default Summary;
